import { memo } from 'react';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { ServiceCode } from 'src/models/price/productCodes';

const TrlKeys = {
    [ServiceCode.BrandingBuilderVacancy]: 'employer.branding.VBCByPiece',
    [ServiceCode.BrandingBuilderPage]: 'employer.branding.Z1',
};

interface TitleProps {
    code: ServiceCode.BrandingBuilderPage | ServiceCode.BrandingBuilderVacancy;
}

const Title: TranslatedComponent<TitleProps> = ({ code, trls }) => {
    return <span>{trls[TrlKeys[code]]}</span>;
};

export default memo(translation(Title));
